import { Directive, Renderer2, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[lmsTooltip]'
})
export class TooltipDirective {
  @Input() tooltipConfig: any;

  constructor(private renderer2?: Renderer2, private elementRef?: ElementRef) {}

  ngOnInit() {
    const tooltipBox = this.renderer2.createElement('div');
    tooltipBox.classList.add('lms-tooltip', this.tooltipConfig.positionV, this.tooltipConfig.positionH);
    const tooltipText = this.renderer2.createText(this.tooltipConfig.text);

    this.renderer2.appendChild(tooltipBox, tooltipText);
    this.renderer2.appendChild(this.elementRef.nativeElement, tooltipBox);
  }

  ngOnChanges() {
    const tooltipBox = this.renderer2.createElement('div');
    tooltipBox.classList.add('lms-tooltip', this.tooltipConfig.positionV, this.tooltipConfig.positionH);
    const tooltipText = this.renderer2.createText(this.tooltipConfig.text);

    this.renderer2.appendChild(tooltipBox, tooltipText);
    this.renderer2.appendChild(this.elementRef.nativeElement, tooltipBox);
  }
}
